module.exports = __webpack_public_path__ + "img/speaker-ErekleInashvili.74ff7fad.png";